import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CurrentUserService } from '../services/current-user.service';
import { redirectProjectListing } from './redirect.helper';

export const canActivateProjectsSPGuard: CanActivateFn = () => {
  const currentUserService = inject(CurrentUserService);
  const isSp = currentUserService.isServiceProvider;

  if (!isSp) {
    redirectProjectListing();
    return false;
  }
  return true;
};
